import { createAction, props } from '@ngrx/store';

/***** Create Virtual Event: BEGIN *****/
export const createVirtualEvent = createAction(
  '[VirtualEvent] Create VirtualEvent'
);

export const createVirtualEventSuccess = createAction(
  '[VirtualEvent] Create VirtualEvent Success',
  props<{ data: any }>()
);

export const createVirtualEventFailure = createAction(
  '[VirtualEvent] Create VirtualEvent Failure',
  props<{ error: any }>()
);
/***** Create Virtual Event: END *****/

/***** Load Virtual Event: BEGIN *****/
export const loadVirtualEvent = createAction(
  '[VirtualEvent] Load VirtualEvent'
);

export const loadVirtualEventSuccess = createAction(
  '[VirtualEvent] Load VirtualEvent Success',
  props<{ data: any }>()
);

export const loadVirtualEventFailure = createAction(
  '[VirtualEvent] Load VirtualEvent Failure',
  props<{ error: any }>()
);
/***** Load Virtual Event: END *****/

/***** Update Virtual Event: BEGIN *****/
export const updateVirtualEvent = createAction(
  '[VirtualEvent] Update VirtualEvent'
);

export const updateVirtualEventSuccess = createAction(
  '[VirtualEvent] Update VirtualEvent Success',
  props<{ data: any }>()
);

export const updateVirtualEventFailure = createAction(
  '[VirtualEvent] Update VirtualEvent Failure',
  props<{ error: any }>()
);
/***** Update Virtual Event: END *****/

/***** Update Virtual Event Stream: BEGIN *****/
export const updateVirtualEventStream = createAction(
  '[VirtualEvent] Update VirtualEventStream'
);

export const updateVirtualEventStreamSuccess = createAction(
  '[VirtualEvent] Update VirtualEventStream Success',
  props<{ data: any }>()
);

export const updateVirtualEventStreamFailure = createAction(
  '[VirtualEvent] Update VirtualEventStream Failure',
  props<{ error: any }>()
);
/***** Update Virtual Event Stream: END *****/

/***** Update Virtual Event Status: BEGIN *****/
export const updateVirtualEventStatus = createAction(
  '[VirtualEvent] Update VirtualEventStatus',
  props<any>()
);

export const updateVirtualEventStatusSuccess = createAction(
  '[VirtualEvent] Update VirtualEventStatus Success',
  props<{ data: any }>()
);

export const updateVirtualEventStatusFailure = createAction(
  '[VirtualEvent] Update VirtualEventStatus Failure',
  props<{ error: any }>()
);
/***** Update Virtual Event Status: END *****/

/***** Update Virtual Event Present: BEGIN *****/
export const updateVirtualEventPresent = createAction(
  '[VirtualEvent] Update VirtualEventPresent',
  props<any>()
);

export const updateVirtualEventPresentSuccess = createAction(
  '[VirtualEvent] Update VirtualEventPresent Success',
  props<any>()
);

export const updateVirtualEventPresentFailure = createAction(
  '[VirtualEvent] Update VirtualEventPresent Failure',
  props<{ error: any }>()
);
/***** Update Virtual Event Present: END *****/

/***** Finalize Virtual Event Auction Item: BEGIN *****/
export const finalizeVirtualEventAuctionItem = createAction(
  '[VirtualEvent] Finalize VirtualEventAuctionItem',
  props<any>()
);

export const finalizeVirtualEventAuctionItemSuccess = createAction(
  '[VirtualEvent] Finalize VirtualEventAuctionItem Success',
  props<any>()
);

export const finalizeVirtualEventAuctionItemFailure = createAction(
  '[VirtualEvent] Finalize VirtualEventAuctionItem Failure',
  props<{ error: any }>()
);
/***** Finalize Virtual Event Auction Item: END *****/

/***** Finalize Virtual Event Auction: BEGIN *****/
export const finalizeVirtualEventAuction = createAction(
  '[VirtualEvent] Finalize VirtualEventAuction',
  props<any>()
);

export const finalizeVirtualEventAuctionSuccess = createAction(
  '[VirtualEvent] Finalize VirtualEventAuction Success',
  props<any>()
);

export const finalizeVirtualEventAuctionFailure = createAction(
  '[VirtualEvent] Finalize VirtualEventAuction Failure',
  props<{ error: any }>()
);
/***** Finalize Virtual Event Auction: END *****/

/***** Show Virtual Event Auction Multi: BEGIN *****/
export const showVirtualEventAuctionMulti = createAction(
  '[VirtualEvent] Show VirtualEventAuctionMulti',
  props<any>()
);

export const showVirtualEventAuctionMultiSuccess = createAction(
  '[VirtualEvent] Show VirtualEventAuctionMulti Success',
  props<any>()
);

export const showVirtualEventAuctionMultiFailure = createAction(
  '[VirtualEvent] Show VirtualEventAuctionMulti Failure',
  props<{ error: any }>()
);
/***** Show Virtual Event Auction Multi: END *****/

/***** Close Virtual Event Silent Auction: BEGIN *****/
export const closeVirtualEventSilentAuction = createAction(
  '[VirtualEvent] Finalize VirtualEventSilentAuction',
  props<any>()
);

export const closeVirtualEventSilentAuctionSuccess = createAction(
  '[VirtualEvent] Finalize VirtualEventSilentAuction Success',
  props<any>()
);

export const closeVirtualEventSilentAuctionFailure = createAction(
  '[VirtualEvent] Close VirtualEventSilentAuction Failure',
  props<{ error: any }>()
);
/***** Close Virtual Event Silent Auction: END *****/

/***** Remove Virtual Event Auction Bid: BEGIN *****/
export const removeVirtualEventAuctionBid = createAction(
  '[VirtualEvent] Remove VirtualEventAuctionBid',
  props<any>()
);

export const removeVirtualEventAuctionBidSuccess = createAction(
  '[VirtualEvent] Remove VirtualEventAuctionBid Success',
  props<any>()
);

export const removeVirtualEventAuctionBidFailure = createAction(
  '[VirtualEvent] Remove VirtualEventAuctionBid Failure',
  props<any>()
);
/***** Remove Virtual Event Auction Bid: BEGIN *****/

/***** Set Virtual Event Presentation Mode: BEGIN *****/
export const setVirtualEventPresentationMode = createAction(
  '[VirtualEvent] Set VirtualEventPresentationMode',
  props<any>()
);

export const setVirtualEventPresentationModeSuccess = createAction(
  '[VirtualEvent] Set VirtualEventPresentationMode Success',
  props<any>()
);

export const setVirtualEventPresentationModeFailure = createAction(
  '[VirtualEvent] Set VirtualEventPresentationMode Failure',
  props<any>()
);
/***** Set Virtual Event Presentation Mode: BEGIN *****/

export const updateVirtualEventData = createAction(
  '[VirtualEvent] Update VirtualEventData',
  props<any>()
);

export const updateVirtualEventDataOptionInfo = createAction(
  '[VirtualEvent] Update VirtualEventDataOptionInfo',
  props<any>()
);

export const updateVirtualEventProgress = createAction(
  '[VirtualEvent] Update VirtualEventProgress',
  props<any>() 
);

export const updateVirtualEventCurrentItem = createAction(
  '[VirtualEvent] Update VirtualEventCurrentItem',
  props<any>()
);

export const clearVirtualEventData = createAction(
  '[VirtualEvent] Clear VirtualEventData'
);

export const updateSponsorSearch = createAction(
  '[VirtualEvent] Update SponsorSearch',
  props<{ payload: string }>()
);

export const updateSlideSearch = createAction(
  '[VirtualEvent] Update SlideSearch',
  props<{ payload: string }>()
);
